/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import BarraPc from "./BarraPc";
import {useEffect, useState} from "react";
import {useLocation} from "react-router";
import {obtenerSeccion} from "../../Utilidades/obtenerSeccion";
import {SECCIONES} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import BarraCell from "./BarraCell";

const Barra = () => {
    const location = useLocation()
    const {masSM} = useResponsive()
    const [oscura, setOscura] = useState(false)

    useEffect(() => {

        let rutas = [SECCIONES[1], 'Detalle', 'DetalleCol', 'DetalleCat', 'Recibo', 'Todos', 'Resultados', 'Nosotras', 'Descuentos']

        let sec = obtenerSeccion(location.pathname)
        if (rutas.includes(sec)) {
            setOscura(true)
        } else {
            setOscura(false)
        }

    }, [location]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            {masSM ?
                <BarraPc negro={oscura}/> :
                <BarraCell negro={oscura}/>
            }

        </Grid>
    )

}
export default Barra